//dependencies
import dropdown from "angular-ui-bootstrap/src/dropdown";
import collapse from "angular-ui-bootstrap/src/collapse";
import tabs from "angular-ui-bootstrap/src/tabs";

//services
// replace: \.(component|directive)\("(\w+)",\s*(\w+)\) with: $2,

//components
import partsOrderContainer from "emun.order/parts/parts-order-container";
import partsOrderDetails from "emun.order/parts/parts-order-details";
import partsOrderHeaderFieldset from "emun.order/parts/parts-order-header-fieldset";
import partsEntryGrid from "emun.order/parts/parts-entry-grid";

//directives
import partsOrderDetailsLines from "emun.order/parts/parts-order-details-lines";
import partsOrderDetailsActions from "emun.order/parts/parts-order-details-actions";
import partsOrderDetailsHeader from "emun.order/parts/parts-order-details-header";
import partsOrderList from "emun.order/parts/parts-order-list";
import partsOrderListGrid from "emun.order/parts/parts-order-list-grid";
import partsOrderListCards from "emun.order/parts/parts-order-list-cards";
import states from "emun.order/parts/parts-order.states";

export const dependencies = [dropdown, collapse, tabs];

export const modules = {
  // modals,
};

//const deps = ["emun.auth", "webutils", "webforms", "webmodals", "ui.router"];

export const services = {};

export const components = {
  partsOrderContainer,
  partsOrderDetails,
  partsOrderDetailsHeader,
  partsOrderHeaderFieldset,
  partsEntryGrid
};

export const directives = {
  partsOrderDetailsLines,
  partsOrderDetailsActions,
  partsOrderList,
  partsOrderListGrid,
  partsOrderListCards,
  partsOrderDetailsHeader
};

export default {
  modules,
  services,
  dependencies,
  components,
  directives,
  states
};
